import { h } from "./createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
var VisualViewportComponent = (function (_super) {
    __extends(VisualViewportComponent, _super);
    function VisualViewportComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visualViewport: null,
            windowInnerWidth: window.innerWidth,
            windowInnerHeight: window.innerHeight,
            qbrowserKeyboardHeight: 0,
        };
        _this.onVisualViewportChange = function (e) {
            _this.setState({
                visualViewport: e.target || window.visualViewport
            });
        };
        _this.onResize = function () {
            _this.setState({
                windowInnerWidth: window.innerWidth,
                windowInnerHeight: window.innerHeight
            });
        };
        _this.onQBKeyboardHeightChange = function (e) {
            _this.setState({
                qbrowserKeyboardHeight: parseInt(e.height || '0', 10)
            });
        };
        return _this;
    }
    VisualViewportComponent.prototype.componentDidMount = function () {
        if (typeof window.visualViewport !== 'undefined') {
            window.visualViewport.addEventListener('resize', this.onVisualViewportChange);
            window.visualViewport.addEventListener('scroll', this.onVisualViewportChange);
        }
        window.addEventListener('resize', this.onResize);
        document.addEventListener('qbrowserKeyboardHeightChange', this.onQBKeyboardHeightChange);
    };
    VisualViewportComponent.prototype.componentWillUnmount = function () {
        if (typeof window.visualViewport !== 'undefined') {
            window.visualViewport.removeEventListener('resize', this.onVisualViewportChange);
            window.visualViewport.removeEventListener('scroll', this.onVisualViewportChange);
        }
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('qbrowserKeyboardHeightChange', this.onQBKeyboardHeightChange);
    };
    VisualViewportComponent.prototype.getStyles = function () {
        var _a = this.state, visualViewport = _a.visualViewport, windowInnerWidth = _a.windowInnerWidth, windowInnerHeight = _a.windowInnerHeight, qbrowserKeyboardHeight = _a.qbrowserKeyboardHeight;
        var styles = __assign({ position: 'fixed', transform: 'translateZ(0)' }, this.props.style || {});
        if (visualViewport != null) {
            styles.left = Math.max(0, Math.min(document.documentElement.scrollWidth - visualViewport.width, visualViewport.offsetLeft)) + 'px';
            styles.top = Math.max(0, Math.min(document.documentElement.scrollHeight - visualViewport.height, visualViewport.offsetTop)) + 'px';
            styles.width = visualViewport.width + 'px';
            styles.height = visualViewport.height + 'px';
        }
        else {
            styles.top = '0';
            styles.left = '0';
            styles.width = windowInnerWidth + 'px';
            styles.height = windowInnerHeight - qbrowserKeyboardHeight + 'px';
        }
        return styles;
    };
    VisualViewportComponent.prototype.render = function () {
        return h("div", { className: 'dui-visual-viewport ' + (this.props.className || ''), style: this.getStyles() }, this.props.children);
    };
    return VisualViewportComponent;
}(React.Component));
export default VisualViewportComponent;
